import React from 'react'
import ReactMarkdown from 'react-markdown'
import { useTranslation } from 'react-i18next'
import Meta from '../components/Meta'
import privacyPolicy from '../content/legal/privacyPolicy'

export default function PrivacyPolicy() {
  const { i18n } = useTranslation()
  const lang = (i18n.language || 'en').split('-')[0]
  const md = privacyPolicy[lang] || privacyPolicy.en

  return (
    <div className="prose mx-auto py-8 px-4">
      <Meta titleKey="legal.pp.meta.title" descKey="legal.pp.meta.description" />
      <ReactMarkdown>{md}</ReactMarkdown>
    </div>
  )
}
